import { isPlainObject } from 'lodash-es';
import { toQueryString } from '@/utils/url';

// let errorHandler;
// export function setAjaxErrorHandler(handler) {
//     errorHandler = handler;
// }

// function handleAjaxError(response) {
//     if (errorHandler) {
//         errorHandler(response);
//     }
// }

// export function jsonOrEmpty(body) {
//     return body.text().then((text) => {
//         return text ? JSON.parse(text) : null;
//     });
// }

function getDefaultParams(): Partial<RequestParameters> {
    // const state = getStore().getState();

    return {
        credentials: 'include',
        headers: {
            // 'Bygr-Locale': state.global.currentCulture ? state.global.currentCulture.locale : '',
        },
    };
}

type RequestParameters = Omit<RequestInit, 'body'> & {
    query?: object | string;
    json?: boolean;
    body?: unknown;
};
// window.addEventListener('unhandledrejection', (e) => {
//     const reason: Response = e.reason;
//     if (reason && !reason.ok && reason.statusText) {
//         handleAjaxError(e.reason.body);
//     }
// });

export async function request(url: string, params: Partial<RequestParameters> = {}) {
    params = {
        ...getDefaultParams(),
        ...params,
    };

    if (!params.headers) {
        params.headers = {};
    }

    // params.headers["Authorization"] = "Bearer " +

    let queryString = '';
    if (params.query && typeof params.query === 'string') {
        queryString = params.query;
    } else if (params.query && isPlainObject(params.query)) {
        queryString = toQueryString(params.query as object);
    }

    if (queryString) {
        url += '?' + queryString;
    }

    if (
        isPlainObject(params.body) ||
        Array.isArray(params.body) ||
        (typeof params.body !== 'object' && typeof params.body !== 'function')
        // params.body instanceof FileData
    ) {
        // await Promise.all(getAllPromises(params.body));

        if (params.body) {
            params.body = params.json ? JSON.stringify(params.body) : toQueryString(params.body as object);
        }
    }

    if (params.json) {
        params.headers['Content-Type'] = 'application/json';
    }

    delete params.query;
    delete params.json;

    let promise = fetch(url, params as RequestInit);

    promise = promise.then((response) => {
        if (!response.ok) {
            return Promise.reject(response);
        }

        return response;
    });

    return promise;
}

/** `request()` rejects with the raw Response; the API puts the message in an `error` property. */
export async function extractErrorMessage(e: unknown): Promise<string | null> {
    try {
        const body = await (e as Response).json();
        return body?.error ?? null;
    } catch {
        return null;
    }
}

// function getAllPromises(obj: any): Promise<any>[] {
//     var promises: Promise<any>[] = [];
//     deepTraverse(obj, (val) => {

//         if (val instanceof FileData) {
//             const promise = val.getDataPromise();
//             if (promise) {
//                 promises.push(promise);
//             }
//         }
//     });

//     return promises;
// }